// FAQ disclosures are native <details>; the summary row toggles on its own.
// This adds one thing: clicking anywhere in an open item's body closes it.
// Purely additive — keyboard and screen-reader toggling stay on <summary>.
// No-ops when `.js-faq` is absent.
export default function faqs() {
  const items = document.querySelectorAll('.js-faq');
  if (!items.length) return;

  items.forEach((item) => {
    item.addEventListener('click', (e) => {
      if (!item.open) return;
      // The summary already toggles natively; a second toggle would reopen it.
      if (e.target.closest('summary')) return;
      // Links in an answer should navigate, not collapse the answer.
      if (e.target.closest('a')) return;
      // A click that ends a text selection is selecting, not closing.
      if (window.getSelection()?.toString()) return;

      item.open = false;
    });
  });
}
